import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { Stack, CircularProgress, useMediaQuery } from "@mui/material";
import { useGetAPIWithoutTokenQuery } from "../Api/api";
import { READ_ALL_EVENTS } from "../Api/apiConstant";
import { useLocation, useNavigate } from "react-router-dom";
import OngoingEvents from "./components/OngoingEvents";
import OrderNow from "./components/OrderNow";
import Howitworks from "../Landing/Components/Howitworks";
import Faq from "../Landing/Components/Faq";
import AppSuggestion from "../Landing/Components/AppSuggestion";
import Footer from "../components/Footer";
import orderThatIconWhite from "../Images/orderThatIconWhite.png";
import { ToastContainer } from "react-toastify";
import LatestUpcomingEvent from "./components/LatestUpcomingEvent";
import { removeAllSession } from "../LoginModule/LoginUtility";
import { useThemeColors } from "../Context/Theme";

const Events = () => {
  const { data: allEvents, isLoading } =
    useGetAPIWithoutTokenQuery(READ_ALL_EVENTS);

  const isMobile = useMediaQuery("(max-width: 425px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  const navigate = useNavigate();
  const location = useLocation();

  const [contentVisible, setContentVisible] = useState(false);
  const [allEventsSlice, setAllEventsSlice] = useState(2);
  const [ongoingSlice, setOngoingSlice] = useState(2);
  const [UpcomingSlice, setUpcomingSlice] = useState(2);

   const {
      primaryColor,
      secondaryColor,
      textColor,
      buttonColor,
      linkColor,
      backgroundColor,
      logo,
      fontFamily,
      fontWeight,
      fontSize,
      fontFamilyHeading,
      fontWeightHeading,
      fontSizeHeading,
    } = useThemeColors();

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => setContentVisible(true), 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    removeAllSession();
    sessionStorage.setItem("isAtAllEvents", true);
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, []);


  const isAtAllEvents = sessionStorage.getItem("isAtAllEvents");

  const ongoingEvents = Array.isArray(allEvents?.data)
    ? allEvents?.data?.filter((event) => {
      const currentDate = new Date();
        const eventStartDate = new Date(event.preorder_start_date);
        const eventEndDate = new Date(event.event_end_date);
        eventStartDate.setHours(0, 0, 0, 0);
        eventEndDate.setHours(23, 59, 59, 999);
        return (currentDate >= eventStartDate && currentDate <= eventEndDate);
    })
    : [];

  const upcomingEvents = Array.isArray(allEvents?.data)
    ? allEvents?.data?.filter((event) => {
      const currentDate = new Date();
      const eventStartDate = new Date(event?.preorder_start_date);
      eventStartDate.setHours(0, 0, 0, 0);
      return (eventStartDate > currentDate)
    })
    : [];

  const latestUpcomingEvent =
    Array.isArray(upcomingEvents) && upcomingEvents?.length
      ? upcomingEvents?.reduce((closest, event) => {
        const eventPreorderStartDate = new Date(event?.preorder_start_date);
        const closestPreorderStartDate = new Date(
          closest?.preorder_start_date
        );
        const currentDate = new Date();

        return eventPreorderStartDate - currentDate <
          closestPreorderStartDate - currentDate
          ? event
          : closest;
      }, upcomingEvents[0])
      : null;

  const notExpiredEvents = Array.isArray(allEvents?.data)
    ? allEvents.data.filter((event) => {
      const eventEndDate = new Date(event.event_end_date).setHours(23, 59, 59, 999);
      const currentDate = new Date();

      return eventEndDate >= currentDate;
    })
    : [];

  return (
    <>
      <ToastContainer />
      <Navbar isAtAllEvents={isAtAllEvents} />
      {isLoading && (
        <Stack
          alignItems={"center"}
          justifyContent={"center"}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#FFF1CA99",
            zIndex: isLoading ? 10 : -1,
            opacity: isLoading ? 1 : 0,
            transition: "opacity 0.5s ease",
          }}
        >
          <CircularProgress sx={{ color: "#FE3B3E" }} />
        </Stack>
      )}

      <Stack
        alignItems={"center"}
        justifyContent={"start"}
        marginTop={"15vh"}
        sx={{
          backgroundColor: "#FFF1CA99",
          transition: "opacity 0.5s ease, transform 0.5s ease",
          opacity: contentVisible ? 1 : 0,
          transform: contentVisible ? "translateY(0)" : "translateY(20px)",
        }}
      >
        {/* {latestUpcomingEvent && (
          <Stack
            sx={{
              width: "100%",
              height: "100%",
              height: "90vh",
              marginBottom: "20px",
            }}
          >
            <LatestUpcomingEvent
              isTablet={isTablet}
              event={latestUpcomingEvent}
              // isMobile={isMobile}
              data={upcomingEvents}
              navigate={navigate}
              title={"Upcoming Events"}
              isMobile={isMobile}
              slice={allEventsSlice}
              setSlice={setOngoingSlice}
            />
          </Stack>
        )} */}
        {!isLoading && ongoingEvents?.length > 0 && (
          <Stack
            alignItems={"center"}
            justifyContent={"start"}
            sx={{
              paddingY: "20px",
              width: "100%",
              height: "100%",
              overflowY: "hidden",
            }}
          >
            <OngoingEvents
              data={ongoingEvents}
              navigate={navigate}
              title={"Ongoing Events"}
              // isMobile={isMobile}
              slice={ongoingSlice}
              setSlice={setOngoingSlice}
              sx={{
                fontSize: fontSize,
                fontFamily: fontFamily,
                fontWeight: fontWeight,
                fontFamilyHeading: fontFamilyHeading,
                fontWeightHeading: fontWeightHeading,
                fontSizeHeading: fontSizeHeading,
                textColor: textColor,
              }}
            />
          </Stack>
        )}
        {contentVisible && <OrderNow />}
        {!isLoading && upcomingEvents?.length > 0 && (
          <Stack
            alignItems={"center"}
            justifyContent={"start"}
            sx={{
              paddingY: "20px",
              width: "100%",
              height: "100%",
              overflowY: "hidden",
              backgroundColor: "#FFF1CA99",
            }}
          >
            <OngoingEvents
              data={upcomingEvents}
              navigate={navigate}
              title={"Upcoming Events"}
              isMobile={isMobile}
              UpcomingSlice={UpcomingSlice}
              setUpcomingSlice={setUpcomingSlice}
              sx={{
                fontSize: fontSize,
                fontFamily: fontFamily,
                fontWeight: fontWeight,
                fontFamilyHeading: fontFamilyHeading,
                fontWeightHeading: fontWeightHeading,
                fontSizeHeading: fontSizeHeading,
                textColor: textColor,
              }}
            />
          </Stack>
        )}
        <Stack
          alignItems={"center"}
          justifyContent={"start"}
          sx={{
            width: "100%",
            height: "100%",
            overflowY: "hidden",
            backgroundColor: "white",
          }}
        >
          <Howitworks id={`howItWorks`} isAtAllEvents={isAtAllEvents} sx={{
                fontSize: fontSize,
                fontFamily: fontFamily,
                fontWeight: fontWeight,
                fontFamilyHeading: fontFamilyHeading,
                fontWeightHeading: fontWeightHeading,
                fontSizeHeading: fontSizeHeading,
                textColor: textColor,

              }}/>
          <Faq id={`faqContainer`} isAtAllEvents={isAtAllEvents} 
          />
          <AppSuggestion isAtAllEvents={isAtAllEvents} />
        </Stack>
      </Stack>
      <Footer
        howitworksId={"howItWorks"}
        faqId={"faqContainer"}
        isAtAllEvents={isAtAllEvents}
        icon={orderThatIconWhite}
      />
    </>
  );
};

export default Events;
